import { render, staticRenderFns } from "./naklodnoyNew.vue?vue&type=template&id=8f9e1b94&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./naklodnoyNew.vue?vue&type=script&lang=js"
export * from "./naklodnoyNew.vue?vue&type=script&lang=js"
import style0 from "./naklodnoyNew.vue?vue&type=style&index=0&id=8f9e1b94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9e1b94",
  null
  
)

export default component.exports